"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JoeApi = void 0;
var runtime = __importStar(require("../runtime"));
var models_1 = require("../models");
/**
 *
 */
var JoeApi = /** @class */ (function (_super) {
    __extends(JoeApi, _super);
    function JoeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    JoeApi.prototype.buildUrl = function (path, queryParameters) {
        var query = this.configuration.queryParamsStringify(queryParameters);
        return "".concat(this.configuration.basePath).concat(path).concat(query && "?".concat(query));
    };
    JoeApi.prototype.getInternalCallInfoForDeleteJoeConnection = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/joe/connection"
        };
    };
    JoeApi.prototype.getUrlForDeleteJoeConnectionByDELETE = function (requestParameters) {
        var _a = this.getInternalCallInfoForDeleteJoeConnection(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * Delete the connection to Joe
     */
    JoeApi.prototype.deleteJoeConnectionRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForDeleteJoeConnection(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete the connection to Joe
     */
    JoeApi.prototype.deleteJoeConnection = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteJoeConnectionRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    JoeApi.prototype.getInternalCallInfoForEstablishJoeConnection = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/joe/connection"
        };
    };
    JoeApi.prototype.getUrlForEstablishJoeConnectionByPOST = function (requestParameters) {
        var _a = this.getInternalCallInfoForEstablishJoeConnection(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * Establish the connection to Joe with the authorization code. If successful, the refresh token will be stored for later usage
     */
    JoeApi.prototype.establishJoeConnectionRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForEstablishJoeConnection(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.EstablishJoeConnectionPayloadToJSON)(requestParameters.establishJoeConnectionPayload),
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.JoeConnectionStatusResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Establish the connection to Joe with the authorization code. If successful, the refresh token will be stored for later usage
     */
    JoeApi.prototype.establishJoeConnection = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.establishJoeConnectionRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JoeApi.prototype.getInternalCallInfoForGetJoeConnectionStatus = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/joe/connection"
        };
    };
    JoeApi.prototype.getUrlForGetJoeConnectionStatusByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetJoeConnectionStatus(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * Get the status of the connection to Joe
     */
    JoeApi.prototype.getJoeConnectionStatusRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetJoeConnectionStatus(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.JoeConnectionStatusResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get the status of the connection to Joe
     */
    JoeApi.prototype.getJoeConnectionStatus = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getJoeConnectionStatusRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    JoeApi.prototype.getInternalCallInfoForGetJoeLoginUrl = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/joe/login-url"
        };
    };
    JoeApi.prototype.getUrlForGetJoeLoginUrlByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetJoeLoginUrl(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * Get the URL to login to Joe
     */
    JoeApi.prototype.getJoeLoginUrlRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetJoeLoginUrl(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.JoeLoginUrlResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get the URL to login to Joe
     */
    JoeApi.prototype.getJoeLoginUrl = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getJoeLoginUrlRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return JoeApi;
}(runtime.BaseAPI));
exports.JoeApi = JoeApi;
//# sourceMappingURL=JoeApi.js.map